import React, { Component } from "react";
import { Grid, Image, Menu } from "semantic-ui-react";
import { Link } from "react-router";
import me from "./me.jpg";

import "./App.css";

class App extends Component {

	render () {

		return (

			<Grid className="app__container" doubling stackable centered>
				<Grid.Row className="app__header">
					<Grid.Column width="3" verticalAlign="middle">
						<Image className="app__header__image" src={me} shape="circular" centered />
					</Grid.Column>
					<Grid.Column width="9" verticalAlign="middle" textAlign="left">
						<h1 className="app__title">Hi there!</h1>
						<span className="app__sub-title">So nice to meet you!</span>
					</Grid.Column>
				</Grid.Row>
				<Grid.Row>
					<Grid.Column width="3">
						<Menu className="app__menu" secondary vertical pointing>
							<Menu.Item>
								<Link className="app__menu__link" activeClassName="app__menu__link--active" to="/about-me">About Me</Link>
							</Menu.Item>
							<Menu.Item>
								<Link className="app__menu__link" activeClassName="app__menu__link--active" to="/case-study">Case Study</Link>
							</Menu.Item>
							<Menu.Item>
								<Link className="app__menu__link" activeClassName="app__menu__link--active" to="/recommendations">Recommendations</Link>
							</Menu.Item>
							<Menu.Item>
								<Link className="app__menu__link" activeClassName="app__menu__link--active" to="/links-examples">Links and Examples</Link>
							</Menu.Item>
						</Menu>
					</Grid.Column>
					<Grid.Column width="9" largeScreen="7" widescreen="7">
						{this.props.children}
					</Grid.Column>
					<Grid.Column width="2" only="large screen"></Grid.Column>
				</Grid.Row>
			</Grid>

		);

	}

}

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/